import React from "react";
import { Reveal, SectionOverline } from "./Shared";

const WhyExercise = () => {
  return (
    <section
      id="why-exercise"
      data-testid="why-exercise-section"
      className="relative py-32 sm:py-40 border-t forr-canvas-alt"
      style={{ borderColor: "var(--forr-line-soft)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <Reveal>
          <SectionOverline
            number="05"
            label="Why Exercise Changes Behavior"
            testId="why-exercise-overline"
          />
        </Reveal>

        <Reveal delay={0.05}>
          <h2
            data-testid="why-exercise-heading"
            className="mt-10 max-w-5xl font-display forr-text-ink text-4xl sm:text-5xl md:text-6xl lg:text-[72px] font-medium tracking-[-0.02em] leading-[1.02]"
          >
            Exercise is not fitness.{" "}
            <span className="forr-text-mute">
              It’s the most direct input we have into the nervous system.
            </span>
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-5">
            <Reveal delay={0.1}>
              <p className="text-lg font-light forr-text-soft leading-relaxed">
                A precisely dosed movement stimulus shifts heart rate variability,
                cortisol, vagal tone, neurotransmitter availability, and the
                autonomic set-point.
              </p>
              <p className="mt-6 text-lg font-light forr-text-soft leading-relaxed">
                In other words: it changes the state your body defaults to — and
                with it, the behavior that state produces.
              </p>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-7 lg:pl-8">
            <div className="grid sm:grid-cols-2 gap-6">
              {[
                {
                  metric: "HRV",
                  label: "Autonomic capacity",
                  body: "Widens the range of stress your system can handle before defaulting.",
                  testId: "exercise-effect-hrv",
                },
                {
                  metric: "Vagal Tone",
                  label: "Parasympathetic access",
                  body: "Faster return to a regulated state after activation.",
                  testId: "exercise-effect-vagal",
                },
                {
                  metric: "BDNF",
                  label: "Neuroplasticity",
                  body: "The neurochemical substrate for laying down new patterns.",
                  testId: "exercise-effect-bdnf",
                },
                {
                  metric: "Cortisol",
                  label: "Stress calibration",
                  body: "Recalibrates the stress response instead of suppressing it.",
                  testId: "exercise-effect-cortisol",
                },
              ].map((c, i) => (
                <Reveal delay={0.15 + i * 0.05} key={c.metric}>
                  <div
                    data-testid={`card-${c.testId}`}
                    className="forr-card rounded-[24px] p-8 h-full"
                  >
                    <div className="flex items-baseline gap-3">
                      <span className="font-display forr-text-teal-deep text-2xl font-medium tracking-tight">
                        {c.metric}
                      </span>
                      <span className="text-[11px] uppercase tracking-[0.24em] forr-text-mute">
                        {c.label}
                      </span>
                    </div>
                    <p className="mt-6 text-sm font-light forr-text-soft leading-relaxed">
                      {c.body}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyExercise;
